import { API_URL } from '../../../../constants'

export const ADD_NEW_EMPLOYEE_URL = `${API_URL}/api/internal/employee/new`
export const BLOCK_EMPLOYEE_URL = `${API_URL}/api/internal/employee/edit/`
export const GET_MERCHANTS_FOR_EMPLOYEE_URL = `${API_URL}/api/internal/merchant/list`
